import { I18NextService } from 'angular-i18next';

export function getTableHeaders(i18: I18NextService) {
  return [
    {
      name: i18.t('shared:licenses.prepayment.wasabiTable.headers.details', { format: 'title' }),
      gridColSize: '10fr',
      gridColMin: '150px'
    },
    {
      name: i18.t('shared:licenses.prepayment.wasabiTable.headers.period', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '200px',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('shared:licenses.prepayment.wasabiTable.headers.unitCost', { format: 'title' }),
      gridColSize: '5fr',
      gridColMin: '200px',
      isGridColumn: false,
      class: '-end',
      overflow: false
    },
    {
      name: i18.t('shared:licenses.prepayment.wasabiTable.headers.quantity', { format: 'title' }),
      gridColSize: '2fr',
      gridColMin: '100px',
      isGridColumn: false,
      overflow: true
    },
    {
      name: i18.t('shared:licenses.prepayment.wasabiTable.headers.total', { format: 'title' }),
      gridColSize: '3fr',
      gridColMin: '50px',
      isGridColumn: false,
      class: '-end',
      overflow: true
    }
  ];
}
